module.exports = __webpack_public_path__ + "static/media/AG77.3f238acf.png";